import { NavLink } from "react-router";
import { useAuth } from "../../contexts/auth/useAuth";
import { roles } from "../../types/Users";


import parse from 'html-react-parser';
import type { Blocs } from "../../types/Blocs";
import { useTrads } from "../../contexts/trads/useTrads";

function BlocsItem({bloc}:{bloc:Blocs}) {
    const {translate}=useTrads();

    const {hasRole} =  useAuth();
    return (
        <div className="row">
            <h2>{bloc.titre}</h2>
            <div>
                {parse(bloc.texte)}
            </div>
            {hasRole(roles.Administrators)?
            <NavLink to={`/blocs/${bloc.id.toString()}/edit`}> {translate('btn_edit')}</NavLink>
            :null}
        </div>
    );
}
export default BlocsItem;